import React from 'react';
import { motion } from 'framer-motion';

interface TwoColumnImagesProps {
  image1: string;
  image2: string;
  alt1: string;
  alt2: string;
}

export const TwoColumnImages: React.FC<TwoColumnImagesProps> = ({ image1, image2, alt1, alt2 }) => {
  return (
    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-10">
      <div className="lg:hidden">
        <img 
          src={image1} 
          alt={alt1} 
          className="w-full"
          loading="eager"
        />
      </div>
      <motion.div
        className="hidden lg:block"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-50px" }}
        transition={{ 
          duration: 0.6, 
          ease: [0.25, 0.46, 0.45, 0.94]
        }}
      >
        <img 
          src={image1} 
          alt={alt1} 
          className="w-full"
          loading="eager"
        />
      </motion.div>

      <div className="lg:hidden">
        <img 
          src={image2} 
          alt={alt2} 
          className="w-full"
          loading="eager"
        />
      </div>
      <motion.div
        className="hidden lg:block"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-50px" }}
        transition={{ 
          duration: 0.6, 
          ease: [0.25, 0.46, 0.45, 0.94]
        }}
      >
        <img 
          src={image2} 
          alt={alt2} 
          className="w-full"
          loading="eager"
        />
      </motion.div>
    </div>
  );
}; 